import React from 'react';

import tmsInternalNoteActivityShape from '../../../../../shapes/tms-internal-note-activity';
import { ACTIVITY_TYPES } from '../../../../../constants';
import NoteSection from '../note-section';
import ActivityWrapper from '../activity-wrapper';
import { formatUsername } from '../../../../../utils/common';

/**
 * Activity note TMS component
 * @param {object} params - Object containing props for this component
 * @return {element} - Activity Note TMS component
 */
const ActivityTmsNote = ({ activity }) => {
  const headerContent = `${formatUsername(activity.initiatorName)} added a Transit (Internal) note in TMS`;
  return (
    <ActivityWrapper
      type={ACTIVITY_TYPES.internalTmsNote}
      headerContent={[{
        text: headerContent,
      }]}
      timestamp={activity.eventTime}
      testId="activity-tms-note"
    >
      <NoteSection note={activity.note} />
    </ActivityWrapper>
  );
};

ActivityTmsNote.propTypes = {
  activity: tmsInternalNoteActivityShape.isRequired,
};

export default ActivityTmsNote;
